import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { CalendarModule, DialogModule, SharedModule } from "primeng/primeng";
import { DirectiveModules } from "../../../modules/directive.modules";
import { ExpiredPendingUnmountingItemsComponent } from "./expired-pending-unmounting-items.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SibGridModule } from "../../../components/sib-forms/grid/grid.module";

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        DirectiveModules,
        DialogModule,
        FormsModule,
        ReactiveFormsModule,
        SibGridModule,
        CalendarModule
    ],
    declarations: [
        ExpiredPendingUnmountingItemsComponent
    ],
    exports: [
        ExpiredPendingUnmountingItemsComponent
    ]
})

export class ExpiredPendingUnmountingItemsModule { }